import { render, staticRenderFns } from "./trainAccountStatus.vue?vue&type=template&id=1fbf9cda&scoped=true&"
import script from "./trainAccountStatus.vue?vue&type=script&lang=ts&"
export * from "./trainAccountStatus.vue?vue&type=script&lang=ts&"
import style0 from "./trainAccountStatus.vue?vue&type=style&index=0&id=1fbf9cda&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fbf9cda",
  null
  
)

export default component.exports